import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {ConsentService} from "./service/consent.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  headerTitle = '';
  logoUrl = '';
  logoUrlSubscription!: Subscription;
  headerTitleSubscription!: Subscription;

  constructor(private route: ActivatedRoute, private consentService: ConsentService) { }

  ngOnInit() {
    this.logoUrlSubscription = this.consentService.getLogoUrlSubject().subscribe((logoUrl) => {
      this.logoUrl = logoUrl;
    });
    this.headerTitleSubscription = this.consentService.getHeaderTitleSubscription().subscribe((headerTitle) => {
      this.headerTitle = headerTitle;
    });
  }

  ngOnDestroy() {
    this.logoUrlSubscription.unsubscribe();
    this.headerTitleSubscription.unsubscribe();
  }

}
